/**
 * Library-only helpers.
 *
 * Originally used to detect ipmi50th.com vs other hostnames when this codebase
 * served both products. Now that the Library is standalone, these always
 * return Library-only values. Kept as helpers so components that import them
 * (TopNav, LoginScreen, KBSidebar, HelpPage) don't need to change.
 */

export const isJubileeHost = () => false;

export const libraryRoot = () => '/';

export const libraryHelpUrl = (extraQs = '') => {
  if (!extraQs) return '/help';
  return '/help' + (extraQs.startsWith('?') ? extraQs : '?' + extraQs);
};
